<template>
     <div>
       <el-dialog
         id="linePopup"
         :visible.sync="showlinePopup"
         width="30%"
         center
         :append-to-body="true"
       >
         <h3 style="text-align: center; margin-bottom: 20px">线路切换</h3>
         <el-divider></el-divider>
         <div>
           <el-row :gutter="20">
             <!-- <el-col :span="12" style="text-align: center">{{item.name}}</el-col>
             <el-col :span="12" style="text-align: center"
               ><el-radio v-model="radio"></el-radio
             ></el-col> -->
             <el-radio-group
               v-model="radio"
               style="display: flex; justify-content: center"
             >
               <el-radio
                 :label="item.id"
                 v-for="(item, index) in lineTypes"
                 :key="index"
                 >{{ item.name }}</el-radio
               >
             </el-radio-group>
           </el-row>
           <el-divider></el-divider>
         </div>
         <el-row>
           <el-col :span="12" style="text-align: center"
             ><el-button
               type="primary"
               plain
               @click="cancelLines"
               style="width: 65%"
               >取消</el-button
             ></el-col
           >
           <el-col :span="12" style="text-align: center"
             ><el-button
               type="primary"
               plain
               @click="ChangeLine"
               style="width: 65%"
               >确定</el-button
             ></el-col
           >
         </el-row>
       </el-dialog>
     </div>
</template>
<script>
   import $ from "jquery";
   export default {
     name: "linePopup",
     components: {},
     data() {
       return {
         showlinePopup: false,
         radio: parseInt(localStorage.getItem("lineUrlId")),
         lineTypes: this.$URLs,
         domainList: this.$URLs,
         urlBaseId: localStorage.getItem("lineUrlId"),
         urlBase: localStorage.getItem("lineUrlText")
       };
     },
     mounted: function () {
      this.getURLs();
     },
     methods: {
       showlineListPopup() {
         this.showlinePopup = true;
       },
       hidelineListPopup() {
         this.showlinePopup = false;
       },
       ChangeLine() {
         let item = this.lineTypes.find((i) => i.id == this.radio);
         if (item) {
           let lineUrl = item.url;
           let lineUrlText = item.name;
           let lineUrlId = item.id;
           localStorage.setItem("lineUrl", lineUrl);
           sessionStorage.setItem("lineUrl", lineUrl);
           localStorage.setItem("lineUrlText", lineUrlText);
           localStorage.setItem("lineUrlId", lineUrlId);
           this.radio = lineUrlId;
           this.showlinePopup = false;
           location.reload();
         }
       },
       cancelLines() {
         this.showlinePopup = false;
       },
        getURLs() {
        let that = this;
        this.lineTypes = [];
        that.domainList.forEach((i, index) => {
          let startTime = new Date().getTime();

          fetch(i.url, { mode: "no-cors" })
            .then((response) => {
              let endTime = new Date().getTime();
              let elapsedTime = endTime - startTime;
              let item = {};
              item.time = elapsedTime;
              item.name = "线路 " + ++index;
              item.id = index;
              item.url = i.url;
              item.value = index;
              // that.lineTypes.push(item);
              this.pushItems(item);
            })
            .catch((error) => {
              console.error(error);
            });
        });

      },
      pushItems(item) {
        this.lineTypes.push(item);
        this.getCurrentLineUrl();
      },
      getCurrentLineUrl() {
        this.lineTypes.forEach((line, index) => {
          if (line.url == this.urlBase) {
            this.radio = line.value;
          }
        });
      },
     },
   };
</script>
<style>
   #linePopup .el-dialog__headerbtn .el-dialog__close {
     display: none;
   }
   
   #linePopup .el-dialog__header {
     display: none;
   }
   
   #linePopup .el-dialog {
     border-radius: 15px;
   }
   
   #linePopup .el-dialog__body {
     padding: 25px 25px 30px !important;
   }
</style>
   
   
   


// WEBPACK FOOTER //
// src/components/common/linepopup.vue